import type { JSX } from 'react';

import { Image, Separator, Text } from '@change/ds-core-ui';

import { CmsHtml } from 'src/app/shared/components/cms';
import { Html } from 'src/app/shared/components/html';

import { usePageBody } from './hooks/usePageBody';

export function PageBody(): JSX.Element {
	const {
		data: { date, categoryName, title, content, styles, photoUrl, mobilePhotoUrl, photoCaption, photoAlt },
	} = usePageBody();

	return (
		<div className="container pb-16 pt-14 lg:max-w-2xl">
			<Text as="span" fontWeight="bold" size="small" className="uppercase text-typography-weak">
				{categoryName}
			</Text>
			<Text as="h1" variant="heading" className="break-words">
				{title}
			</Text>
			<Text as="span" size="medium" className="text-typography-weak">
				{date}
			</Text>
			{photoUrl && mobilePhotoUrl && (
				<div className="pb-6 pt-10 md:pb-10">
					<div className="block md:hidden">
						<Image
							src={mobilePhotoUrl}
							className="h-44 w-full object-cover"
							alt={photoAlt || ''}
							role={photoCaption ? 'img' : 'presentation'}
							aria-describedby={photoCaption ? 'news-photo-caption' : undefined}
						/>
					</div>
					<div className="hidden md:block">
						<Image
							src={photoUrl}
							className="h-80 w-full object-cover"
							alt={photoAlt || ''}
							role={photoCaption ? 'img' : 'presentation'}
							aria-describedby={photoCaption ? 'news-photo-caption' : undefined}
						/>
					</div>
					{photoCaption && (
						<>
							<Text id="news-photo-caption" as="div" className="mt-2 italic" size="x-small">
								<Html html={photoCaption} />
							</Text>
							<Separator orientation="horizontal" />
						</>
					)}
				</div>
			)}
			<CmsHtml html={content} styles={styles} />
		</div>
	);
}
